export const HEALTH_DATES_STALE_TIME = 3 * 60 * 1000; // 3 minutes
